// Local
import {
  UPDATE_SELECTED,
  UPDATE_LIST,
  APPEND_LIST
} from '../reducer/patient'
import { API_URL } from '../constant'
import { api } from './api'
import { searchGenerator } from './search'
import store from '../store'
import { UPDATE_ENCOUNTER_CONDITIONS } from '../reducer/condition'
import { EncounterConditionDisplay } from '../component/authenticated/types'

export const updateEncounterConditions = (
  conditions: EncounterConditionDisplay[]
) => ({
  type: UPDATE_ENCOUNTER_CONDITIONS,
  payload: conditions
})

export const clearSelected = () => ({
  type: UPDATE_SELECTED,
  payload: {}
})

export const updateList = (list: any) => ({
  type: UPDATE_LIST,
  payload: list
})

export const appendList = (list: any) => ({
  type: APPEND_LIST,
  payload: list
})

export type LoadPatientsProps = {
  query?: any
  limit?: number | undefined
  offset?: number
  sort: string
  queryOverride?: any
  append?: any
  userRole: string
}

export const loadPatients = (props: LoadPatientsProps) => {
  const {
    query = undefined,
    limit = undefined,
    offset = undefined,
    sort,
    queryOverride = undefined,
    append = undefined,
    userRole
  } = props
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  const params = searchGenerator(query, limit, offset, sort, queryOverride)
  const { dispatch } = store
  return api.get(API_URL.GET_PATIENT_WITH_ROLE(userRole), { params }).then(({ data }) => {
    if (!append) {
      dispatch(updateList(data))
    } else {
      dispatch(appendList(data))
    }
  }).catch(() => {
    // 403 errors are already handled by api.defaultErrorHandler
  })
}
